import { render, staticRenderFns } from "./DiscoveryPanelDrawer.vue?vue&type=template&id=3bf1de5d&scoped=true&"
import script from "./DiscoveryPanelDrawer.vue?vue&type=script&lang=js&"
export * from "./DiscoveryPanelDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf1de5d",
  null
  
)

export default component.exports